/**
 * Klaviyo tracking for the general contact form (#ContactForm):
 * identify the visitor and fire a "Contact Form" event on submit.
 * The form still submits natively; tracking is fired before unload.
 */
(() => {
  const getFormData = (form) => {
    const value = (selector) => {
      const field = form.querySelector(selector);
      return field ? field.value.trim() : '';
    };
    return {
      name: value('#ContactForm-name'),
      email: value('#ContactForm-email'),
      phone: value('#ContactForm-phone'),
      message: value('#ContactForm-body'),
    };
  };

  const trackSubmit = (form) => {
    try {
      if (typeof window.klaviyo === 'undefined') {
        console.warn('Klaviyo is not loaded. Contact form tracking will not work.');
        return;
      }
      const formData = getFormData(form);
      const trackData = {
        event: 'Submitted contact form',
        form_type: 'contact',
        timestamp: new Date().toISOString(),
        page_url: window.location.href,
      };
      if (formData.email) trackData.email = formData.email;
      if (formData.name) trackData.name = formData.name;
      if (formData.phone) trackData.phone = formData.phone;
      if (formData.message) trackData.message = formData.message;

      const performTracking = () => klaviyo.track('Contact Form', trackData);

      if (formData.email) {
        const identifyData = { $email: formData.email };
        if (formData.name) {
          const nameParts = formData.name.split(/\s+/);
          identifyData.$first_name = nameParts[0];
          if (nameParts.length > 1) identifyData.$last_name = nameParts.slice(1).join(' ');
        }
        if (formData.phone) identifyData.$phone_number = formData.phone;
        klaviyo.identify(identifyData, performTracking);
      } else {
        performTracking();
      }
    } catch (error) {
      console.error('Error tracking contact form:', error);
    }
  };

  const init = () => {
    const form = document.querySelector('#ContactForm');
    if (!form) return;
    form.addEventListener('submit', () => {
      if (window.themeAnalytics) {
        window.themeAnalytics.trackEvent('contact_enquiry_submitted', { form_type: 'contact' });
      }
      trackSubmit(form);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
